import { OTPSelectVerificationTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const OTPSelectVerificationTrackingSchema: Record<
  OTPSelectVerificationTrackingPoint,
  string
> = {
  [OTPSelectVerificationTrackingPoint.PageView]:
    '2b6fc4e1-dd2d-4a61-b017-a7d6ed16c504',
  [OTPSelectVerificationTrackingPoint.CallButtonClick]:
    '03dd981f-8b39-4c5a-b0d5-a04b5f520463',
  [OTPSelectVerificationTrackingPoint.SmsButtonClick]:
    '15b81b88-28f0-49b9-9e2e-64f2ec56b511',
  [OTPSelectVerificationTrackingPoint.WhatsAppButtonClick]:
    '640eb2cb-11de-4320-8dfb-4f91b2d06ee7',
  [OTPSelectVerificationTrackingPoint.BackButtonClick]:
    '835e9f13-8b3b-411f-a3fa-897f3222a0b2',
  [OTPSelectVerificationTrackingPoint.HelpButtonClick]:
    'd19ec490-70cd-49b1-b648-0a7cc04480e7',
  [OTPSelectVerificationTrackingPoint.ViberButtonClick]:
    '17316dde-ad09-4868-92d6-f698fb9f78b9',
  [OTPSelectVerificationTrackingPoint.ZaloButtonClick]:
    'feadbaf2-21b0-4596-82c0-84d71071e10b',
};

export const getOTPSelectVerificationPageTypeAndSchema = (
  trackingPoint: OTPSelectVerificationTrackingPoint
) => {
  return {
    page_type: PageType.OTPSelectVerificationMethodPage,
    schema: OTPSelectVerificationTrackingSchema[trackingPoint],
  };
};
